import React from "react";
import LiveStreamsPage from "./pages/LiveStreamsPage";
import RecentPage from "./pages/RecentPage";
import PlaylistPage from "./pages/PlaylistPage";
import HomePage from "./pages/HomePage";
import ReactTooltip from "react-tooltip";
import VideoCarousel from "../Home/VideoCarousel";

import {
  parseText,
  parseLive,
  parseSubscriptionTitle,
} from "../../Helpers/parse";
import { getQueryVariable } from "../../Helpers/QueryString";
import AllVideos from "./AllVideos";
import { BASE_PATH } from "../../constants/awsBaseUrl";

const PlaylistIcon = () => (
  <>
    <i className="fas fa-play-circle ml-3" data-tip data-for="GoToPlayList"></i>
    <ReactTooltip id="GoToPlayList" type="dark" effect="solid" place="right">
      <span>Go to Playlist</span>
    </ReactTooltip>
  </>
);

const Home = ({
  user,
  color,
  refresh,
  config,
  register, //could use this to open model maybe??
  payload,
  setFile,
  setPlaylist,
  fetchPlaylist,
}) => {

  /*
   * PLAYLISTS PAGE
   */
  let playlist =
    payload && payload.playlists
      ? payload.playlists
          .filter((playlistObj) => playlistObj)
          .map((playlistObj) => {
            return (
              <VideoCarousel
                key={playlistObj.name}
                header={
                  <>
                    {parseSubscriptionTitle(playlistObj.name)}
                    <PlaylistIcon />
                  </>
                }
                onClickHeader={() =>
                  setPlaylist(playlistObj.videos, playlistObj.name)
                }
                loadContent={() => {
                  if (fetchPlaylist) {
                    return fetchPlaylist(playlistObj.name);
                  } else {
                    return Promise.resolve();
                  }
                }}
                videos={playlistObj.videos}
                category={playlistObj.name}
                color={color}
                setFile={setFile}
                setPlaylist={setPlaylist}
              />
            );
          })
      : [];

  let contents;
  
  // Switch statement determines which page to render
  switch (getQueryVariable("page")) {

    case "LIVE":
      contents = (
        <LiveStreamsPage 
          payload={payload} 
          setFile={setFile} 
          color={color} 
          parseText={parseText}
          parseLive={parseLive}/>
      )
      break;

    case "PLAYLIST":
      contents = playlist;
      break;
    case "ALL":
    contents = (
      <AllVideos user={user} setFile={setFile}/>
    );
    break;
    case "RECENT":
      contents = (
        <div>
          <p className="home-section-header">Recent</p>
          <div className="row mb-3 border-bottom" style={{display:'flex', justifyContent:'center'}}>
            <RecentPage 
              payload={payload} 
              setFile={setFile} 
              color={color}/>
          </div>
        </div>
      );
      break;

    default:
      contents = ( 
        <HomePage 
          config={config}
          payload={payload} 
          setFile={setFile} 
          color={color}
          setPlaylist={setPlaylist}
          parseSubscriptionTitle={parseSubscriptionTitle}/>
      )
      break;
  }
  
  // *RENDERS THE RETURNED PAGE FROM SWITCH STATEMENT
  return (
    <div className="custom-container mt-3">
     <div
        className="banner mb-3"
        style={{backgroundImage: `url('${BASE_PATH}/banners/${user}/banner.jpg?refresh=${refresh}')`}}
      ></div>


      {contents}
    </div>
  );
};

export default Home;
